module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-catch-links@5.16.0_gatsby@5.16.1_babel-eslint@10.1.0_eslint@7.32.0__react_f696c644722c76499e68e31e00268481/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-mixpanel@4.1.0_gatsby@5.16.1_babel-eslint@10.1.0_eslint@7.32.0__react-dom_d4b7edc6637ec900ab54397f998f4522/node_modules/gatsby-plugin-mixpanel/gatsby-browser.js'),
      options: {"plugins":[],"apiToken":null,"enableOnDevMode":false,"mixpanelConfig":{"ignore_dnt":false},"pageViews":{"/support/":"Homepage: Viewed Support","/support/getting-started/":"Homepage: Viewed Getting Started","/support/integrations/xero/faq/":"Homepage: Viewed Xero FAQ"}},
    },{
      plugin: require('../gatsby-browser.ts'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.16.1_babel-eslint@10.1.0_eslint@7.32.0__react-dom@18.3.1_react@18.3.1__react@1_fc416cfd9aab7ba6305b38003cd423de/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
